export default "__VITE_ASSET__DsWs6zln__"